import { defineStore } from 'pinia'
import { store } from '../index'
import { getGroups } from '@/func'

export const useCommonStore = defineStore({
  id: 'Common',
  state: () => ({
    loginPageSetting: null as any,
    portalPageSetting: null as any,
    serviceSetting: {},
    groups: [],
    nodes: {},
    rawNodeTree: {},
  }),
  getters: {
    getServiceSettings(): any {
      return this.serviceSetting
    },
  },
  actions: {
    getGroups(payload: any) {
      return this.groups
    },
    getRawNodeTree(payload: any) {
      return this.rawNodeTree[payload.grpName]?this.rawNodeTree[payload.grpName]:[]
    },
    getNodes(payload: any) {
      return this.nodes[payload]?this.nodes[payload]:[]
    },
    setGroups(payload: any) {
      this.groups = payload
    },
    setRawNodeTree(payload: any) {
      this.rawNodeTree[payload.grpName] = payload.data
    },
    setNodes(payload: any) {
      this.nodes[payload.grpName] = payload.data
    },
    removeNodesByGroup(payload: any) {
      delete this.nodes[payload]
    },
    clearNodes(payload: any) {
      this.nodes = {}
      this.rawNodeTree = {}
    },
    setLoginPageSetting(payload: any) {
      console.log('setLoginPageSetting:', payload)
      this.loginPageSetting = payload
    },
    setPortalPageSetting(payload: any) {
      console.log('setPortalPageSetting:', payload)
      this.portalPageSetting = payload
    },
    setServiceSetting(payload: any) {
      console.log('setServiceSetting:', payload)
      this.serviceSetting[payload.service_type] = payload
    },
    delServiceSetting(payload: any) {
      console.log('delServiceSetting:', payload)
      delete this.serviceSetting[payload]
    }
  }
})

export const useCommonStoreWithOut = () => {
  return useCommonStore(store)
}
